<template>
    <article class="newsCard"
             :class="[
                 `newsCard--${colour ?? 'pink'}`,
                 modifier.length > 0 ? `newsCard--${modifier}` : ''
             ]"
    >
        <a :href="url" class="newsCard__link">
            <div class="newsCard__img">
                <img v-if="img && img.hasOwnProperty('url')"
                     :src="img.url"
                     :alt="`${title} Thumbnail`"
                     :height="img.hasOwnProperty('height') ? img.height : 284"
                     :width="img.hasOwnProperty('width') ? img.width : 546"
                     draggable="false"
                     loading="lazy"
                />
            </div>

            <div class="newsCard__text">
                <ul v-if="categories" class="pills newsCard__pills">
                    <li v-for="(item, i) in categories"
                        :key="i"
                        class="pill newsCard__pill"
                    >{{ item.name }}</li>
                </ul>

                <h1 v-if="title" class="newsCard__title" v-html="title" />

                <div class="newsCard__readMore">
                    Read more

                    <span class="newsCard__readMoreIcon">
                        <svg width="13" height="11" viewBox="0 0 13 11">
                            <path d="M7.266 0L6.4183 0.883021L9.8091 4.4151H0V5.67656H9.8091L6.4183 9.20865L7.266 10.0917L12.11 5.04583L7.266 0Z" fill="currentColor"/>
                        </svg>
                    </span>
                </div>
            </div>
        </a>
    </article>
</template>

<script>
export default {
    name: "NewsCard",
    props: {
        url: {
            type: String,
            default() {
                return "";
            }
        },
        title: {
            type: String,
            default() {
                return "";
            }
        },
        categories: {
            type: Array,
            default() {
                return [];
            }
        },
        img: {
            type: Object,
            default() {
                return {
                    url: "",
                    height: 284,
                    width: 546
                }
            }
        },
        colour: {
            type: String,
            default() {
                return "";
            }
        },
        modifier: {
            type: String,
            default() {
                return "";
            }
        },
    },
}
</script>

